(function() {
    'use strict';

    const TR = angular.module('TR');
    TR.directive('platform195ConvTracking', platform195ConvTracking);

    function platform195ConvTracking($timeout) {
        return {
            restrict: 'A',
            scope: '@',
            link() {

                const getJSON = obj => {
                    return obj && JSON.parse(obj);
                };

                const generatePixel = url => {
                    let success = false;
                    if (!url) {
                        return { success };
                    }
                    const img = new Image();
                    img.src = url;
                    success = true;
                    return {
                        img,
                        success
                    };
                };

                const initConversionPixel = (id, url) => {
                    if (!id) { return; }
                    localStorage.getItem(`platform195Conv${id}`);

                    if (url) {
                        const success = generatePixel(url).success;

                        if (success) {
                            generatePixel(url);
                        }

                        if (url && success) {
                            $timeout(localStorage.removeItem(`platform195Conv${id}`), 5000);
                        }
                    }
                };

                const bookingRef = sessionStorage.getItem('preselectedHotelData');
                const bookingData = bookingRef !== null ? bookingRef : '';

                const getPlatform195Conv = id => {
                    if (!id) { return; }

                    const value = localStorage.getItem(`platform195Conv${id}`);
                    const serialized = value !== null ? value : '';
                    return serialized;
                };

                const getEstabId = data => {
                    if (!data) { return; }
                    const json = getJSON(data);
                    if (!json) { return; }
                    const { d } = json;
                    const id = _.get(d, '.Itinerary.EstabId');
                    return id;
                };

                const getPreSelectedData = (data, id) => {
                    if (!data) { return; }
                    const bookingData = getPlatform195Conv(id);
                    if (!bookingData) { return; }
                    return getJSON(bookingData);
                };

                const platform195Conv = bookingData => {
                    if (!bookingData) { return; }
                    const estabId = getEstabId(bookingData);
                    const { hotelId, conversionUrl, isSponsoredEstab } = getPreSelectedData(bookingData, estabId) || {};

                    if ((!conversionUrl && !isSponsoredEstab) || (estabId !== hotelId)) {
                        return;
                    }
                    initConversionPixel(estabId, conversionUrl);
                };

                if (!bookingData) {
                    return;
                }

                platform195Conv(bookingData);

            }
        };
    }
})();
